import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ['buttonShowSearch', 'buttonHideSearch', 'buttonShowMenu', 'buttonHideMenu'];

    showSearch() {
        this.buttonShowSearchTarget.classList.add('hidden')
        this.buttonHideSearchTarget.classList.remove('hidden')
        this.element.getElementsByClassName('search')[0].classList.add('flex')
        this.hideMenu()
        document.getElementById('search-textbox').focus()
    }

    hideSearch() {
        this.buttonHideSearchTarget.classList.add('hidden')
        this.buttonShowSearchTarget.classList.remove('hidden')
        this.element.getElementsByClassName('search')[0].classList.remove('flex')
    }

    showMenu() {
        this.buttonShowMenuTarget.classList.add('hidden')
        this.buttonHideMenuTarget.classList.remove('hidden')
        this.element.getElementsByClassName('header-menu')[0].classList.remove('hidden')
        this.hideSearch()
    }

    hideMenu() {
        this.buttonHideMenuTarget.classList.add('hidden')
        this.buttonShowMenuTarget.classList.remove('hidden')
        this.element.getElementsByClassName('header-menu')[0].classList.add('hidden')
    }
}
